// frontend/src/services/axiosConfig.js
import axios from 'axios';
import { triggerLogout } from '../contexts/AuthContext';

// Utility function to extract a cookie by name
const getCookie = (name) => {
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const found = cookies.find(row => row.startsWith(name + '='));
    return found ? decodeURIComponent(found.split('=')[1]) : null;
};

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL, // This is now '/api' in production
    withCredentials: true,
});

// Request Interceptor (for adding CSRF token to relevant requests)
axiosInstance.interceptors.request.use((config) => {
    const methodsRequiringCsrf = ['POST', 'PUT', 'DELETE', 'PATCH'];
    if (methodsRequiringCsrf.includes(config.method.toUpperCase())) {
        const csrfToken = getCookie('XSRF-TOKEN');
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken;
        } else {
            console.warn('CSRF token cookie (XSRF-TOKEN) not found for protected request.');
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Response Interceptor (for handling Authentication Errors globally)
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            const originalRequestUrl = error.config.url;

            // --- CORRECTED PATHS: The '/api' prefix is removed ---
            const isAuthEndpoint = originalRequestUrl === '/auth/status' ||
                                   originalRequestUrl === '/auth/login' ||
                                   originalRequestUrl === '/auth/register';
            // --- END CORRECTION ---

            if (!isAuthEndpoint) {
                console.warn(`Authentication error (${error.response.status}) detected on API call to '${originalRequestUrl}'. Triggering global logout.`);
                triggerLogout();
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;